import React from "react";
// import "./Testimonials.css";
import "../styles/Testimonials.css";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

/* ================= TESTIMONIAL DATA ================= */

const fcsReviews = [
  {
    text: "THEY HELPED US FIND QUALIFIED CANDIDATES WITHIN DAYS. THE HIRING PROCESS BECAME FASTER AND SMOOTHER.",
    name: "PROJECT MANAGER",
    role: "IT CONSULTING FIRM",
    img: "https://i.pravatar.cc/80?img=12",
  },
  {
    text: "THEIR TRAINING AND PLACEMENT SUPPORT GAVE ME CONFIDENCE AND HELPED ME START MY IT CAREER.",
    name: "SOFTWARE TRAINEE",
    role: "PLACED CANDIDATE",
    img: "https://i.pravatar.cc/80?img=22",
  },
  {
    text: "WE RECEIVED PERFECTLY MATCHED PROFESSIONALS ALIGNED WITH OUR PROJECT REQUIREMENTS.",
    name: "HR DIRECTOR",
    role: "TECH COMPANY",
    img: "https://i.pravatar.cc/80?img=32",
  },
  {
    text: "CAREER GUIDANCE AND MENTORSHIP HELPED ME GROW FASTER THAN I EXPECTED IN THE INDUSTRY.",
    name: "CLOUD ENGINEER",
    role: "FCS GRADUATE",
    img: "https://i.pravatar.cc/80?img=41",
  },
  {
    text: "THEIR STAFFING SOLUTIONS ARE RELIABLE AND TAILORED EXACTLY TO BUSINESS NEEDS.",
    name: "OPERATIONS LEAD",
    role: "ENTERPRISE CLIENT",
    img: "https://i.pravatar.cc/80?img=51",
  },
  {
    text: "FROM TRAINING TO PLACEMENT, THE ENTIRE JOURNEY WAS SUPPORTIVE AND PROFESSIONAL.",
    name: "BUSINESS ANALYST",
    role: "PLACED CANDIDATE",
    img: "https://i.pravatar.cc/80?img=61",
  }
];

/* ================= ANIMATION ================= */

const cardMotion = {
  hidden: { opacity: 0, y: 70, scale: 0.95 },
  show: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.6, ease: "easeOut" }
  }
};


const Testimonials = () => {
  return (
    <section className="solutions-section">
      <div className="solutions-header">
        <h2 className="testmonial-badge" style={{ display: 'inline-block' }}>
          TESTIMONIALS
        </h2>

        <h2 className="section-title">
          TRUSTED BY INDUSTRY <span className="purple-text">LEADERS</span>
          <br />
          <span className="purple-text">WORLDWIDE</span>
        </h2>
      </div>

      {/* SLIDER */}
      <div className="fcs-slider-area container">

        <Swiper
          modules={[Navigation, Autoplay]}
          navigation={{
            nextEl: ".fcs-next",
            prevEl: ".fcs-prev",
          }}
          autoplay={{
            delay: 3500,
            disableOnInteraction: false,
          }}
          loop={true}
          spaceBetween={26}
          breakpoints={{
            0: { slidesPerView: 1 },
            600: { slidesPerView: 1.2 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
        >
          {fcsReviews.map((item, i) => (
            <SwiperSlide key={i} className="h-100 d-flex">
              <motion.div
                className="fcs-card h-100 w-100"
                variants={cardMotion}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, margin: "-80px" }}
              >
                <p className="fcs-text">“{item.text}”</p>

                <div className="fcs-user">
                  <img src={item.img} alt={item.name} />

                  <div>
                    <h4>{item.name}</h4>
                    <span>{item.role}</span>
                  </div>
                </div>

                <div className="fcs-stars">★★★★★</div>
              </motion.div>
            </SwiperSlide>
          ))}

        </Swiper>

        {/* NAVIGATION */}
        <div className="fcs-prev">‹</div>
        <div className="fcs-next">›</div>
      </div>
    </section>
  );
};

export default Testimonials;
